import React from 'react'
import { Link } from 'react-router-dom'

import MobileNavigation from './components/mobileNavigation'
import Navigation from './components/navigation'
import Footer from './components/footer'

import './scss/style.scss'

const Templates = () => (
  <>
    <MobileNavigation />

    <header className="pt-120 bg-light header_1">
      <Navigation />
    </header>
    <section className="pt-105 pb-100 bg-dark showcase_5">
      <div className="container px-xl-0">
        <div className="row justify-content-center text-center color-white">
          <div className="col-xl-9 col-lg-10">
            <h1>Free Bootstrap Templates</h1>
            <div className="mt-25 mb-40 f-22 text-adaptive">
          Browse a regularly updated catalog of free Bootstrap templates.
              {' '}
              <br />
          Download Bootstrap templates directly from our collection and customize them. These templates are fully customized and ready-made designed websites you can use free for you and your clients.
            </div>
          </div>
        </div>
        <div className="row justify-content-center text-center text-md-left">
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_1.jpg" srcSet="/images/templates/showcase_5_img_1@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            App Website Template
              </div>
              <div className="color-heading text-adaptive">
            Bring more focus to your website application with this elegant and feature-packed Bootstrap template.
              </div>
              <a href="https://preview.bootstrap.build/appwebsite/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/appwebsite.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_2.jpg" srcSet="/images/templates/showcase_5_img_2@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            Homepage Template
              </div>
              <div className="color-heading text-adaptive">
            The loud and imposing Homepage template is precisely what is needed to make the first impression counts.
              </div>
              <a href="https://preview.bootstrap.build/homepage/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/homepage.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_3.jpg" srcSet="/images/templates/showcase_5_img_3@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            Landing Page Template
              </div>
              <div className="color-heading text-adaptive">
            Working for every occasion, this splendid landing page design templates will become your perfect starting point.
              </div>
              <a href="https://preview.bootstrap.build/landingpage/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/landingpage.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_4.jpg" srcSet="/images/templates/showcase_5_img_4@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            Material Design Template
              </div>
              <div className="color-heading text-adaptive">
            Based on well-established Google’s principles, material design templates provides the best user experience ever.
              </div>
              <a href="https://preview.bootstrap.build/materialdesign/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/materialdesign.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_5.jpg" srcSet="/images/templates/showcase_5_img_5@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            One-Page Template
              </div>
              <div className="color-heading text-adaptive">
            One-Page template does not mean simplistic. It has a powerful toolset to make your brand heard.
              </div>
              <a href="https://preview.bootstrap.build/onepage/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/onepage.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_6.jpg" srcSet="/images/templates/showcase_5_img_6@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            Online Store Template
              </div>
              <div className="color-heading text-adaptive">
            Going e-commerce is not easy, but with this smart, handcrafted online store template, it will be a mere pleasure.
              </div>
              <a href="https://preview.bootstrap.build/onlinestore/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/onlinestore.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_7.jpg" srcSet="/images/templates/showcase_5_img_7@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            Portfolio Template
              </div>
              <div className="color-heading text-adaptive">
            Self-presentation matters; that is why this excellent portfolio template treats the content like a piece of art.
              </div>
              <a href="https://preview.bootstrap.build/portfolio/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/portfolio.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_8.jpg" srcSet="/images/templates/showcase_5_img_8@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            Real Estate Template
              </div>
              <div className="color-heading text-adaptive">
            Location, location, location. This Real Estate template has the best information structure to accommodate the offers.
              </div>
              <a href="https://preview.bootstrap.build/realestate/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/realestate.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>

          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img alt="" className="radius10 noradius_bottom w-full" src="/images/templates/showcase_5_img_9.jpg" srcSet="/images/templates/showcase_5_img_9@2x.jpg 2x" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">
            Services Website Template
              </div>
              <div className="color-heading text-adaptive">
            Coming with a bunch of field-tested components, services website template is ready to get down to business.
              </div>
              <a href="https://preview.bootstrap.build/service/index.html" target="_blank" rel="noopener noreferrer" className="btn mt-20 mr-10 sm action-2 f-16">Preview</a>
              <a href="/download/service.zip" className="btn mt-20 sm border-gray color-main f-16" download>Download</a>
            </div>
          </div>
        </div>
        <div className="row justify-content-center text-center color-white">
          <div className="col-xl-9 col-lg-10">
            <div className="mt-65 mb-40 f-22 text-adaptive">
          Sponsored by Designmodo's Startup, a
              {' '}
              <a className="link color-blue" href="https://designmodo.com/startup/" target="_blank" rel="noopener noreferrer">Bootstrap Builder</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="pt-105 pb-100 bg-light text-center pricing_table_7">
      <div className="container px-xl-0">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <h2 className="mb-15 small">Cost?</h2>
          </div>
          <div className="col-xl-6 col-lg-7 col-md-8 col-sm-10">
            <div className="mb-50 f-22 color-heading text-adaptive">
          Bootstrap.build is a free Bootstrap builder.
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-8 col-sm-10">
            <div className="pt-40 pb-45 radius10 inner">
              <div className="row justify-content-center no-gutters">
                <div className="col-xl-7 col-lg-8 col-sm-9 col-11">
                  <div className="f-28 title">
                100% Free
                  </div>
                  <div className="mt-25 f-14 text-uppercase semibold sp-20">
                18.000 users
                  </div>
                  <ul
                    style={{ listStyleType: 'none', padding: 0, marginBottom: 0 }}
                    className="mt-10 color-heading f-18 medium text-adaptive"
                  >
                    <li>Advanced bootstrap builder mode</li>
                    <li>Import / export themes</li>
                    <li>Unlimited private projects</li>
                    <li>Auto-updated CDN</li>
                    <li>Export SASS and CSS</li>
                    <li>Reuse hundreds of free themes</li>
                  </ul>
                  <Link to="/signup" className="btn mt-35 lg action-2">Sign Up</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </>
)

export default Templates
